import types from '../../actions/types'
import {combineReducers} from 'redux'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_PRINT_TEMPLATE_DIALOG:
      return true
    case types.HIDE_PRINT_TEMPLATE_DIALOG:
      return false
    default:
      return state
  }
}

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_PRINT_TEMPLATE_DIALOG:
      return false
    case types.HIDE_PRINT_TEMPLATE_DIALOG:
      return false
    case types.PRINT_TEMPLATES_ADD_PRINT_TEMPLATE_ATTEMPT:
      return true
    case types.PRINT_TEMPLATES_ADD_PRINT_TEMPLATE_SUCCESS:
      return false
    case types.PRINT_TEMPLATES_ADD_PRINT_TEMPLATE_FAILURE:
      return false
    case types.PRINT_TEMPLATES_DUPLICATE_PRINT_TEMPLATE_ATTEMPT:
      return true
    case types.PRINT_TEMPLATES_DUPLICATE_PRINT_TEMPLATE_SUCCESS:
      return false
    case types.PRINT_TEMPLATES_DUPLICATE_PRINT_TEMPLATE_FAILURE:
      return false
    default:
      return state
  }
}

export const printTemplateGroupId = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_PRINT_TEMPLATE_DIALOG:
      return action.printTemplateGroupId
    case types.HIDE_PRINT_TEMPLATE_DIALOG:
      return null
    default:
      return state
  }
}

export const printTemplateId = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_PRINT_TEMPLATE_DIALOG:
      return action.printTemplateId
    case types.HIDE_PRINT_TEMPLATE_DIALOG:
      return null
    default:
      return state
  }
}

export const printTemplateType = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_PRINT_TEMPLATE_DIALOG:
      return action.printTemplateType
    case types.HIDE_PRINT_TEMPLATE_DIALOG:
      return null
    default:
      return state
  }
}

export const printTemplateRouteType = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_PRINT_TEMPLATE_DIALOG:
      return action.printTemplateRouteType
    case types.HIDE_PRINT_TEMPLATE_DIALOG:
      return null
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  isLoading,
  printTemplateGroupId,
  printTemplateId,
  printTemplateType,
  printTemplateRouteType,
})
